/**
 * テキストリビールアニメーション
 *
 * .js-text-reveal を付与した要素が画面内に入ったタイミングで
 * opacity + translateY でスッと浮かび上がらせる。
 * 初期状態（非表示）は CSS で設定済み。GSAP が使えない場合は
 * is-text-reveal-active クラスを付与して CSS トランジションにフォールバック。
 */
document.addEventListener("DOMContentLoaded", function () {
  var targets = document.querySelectorAll(".js-text-reveal");
  if (!targets.length) return;

  var reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  if (
    reduceMotion ||
    typeof window.gsap === "undefined" ||
    typeof window.ScrollTrigger === "undefined"
  ) {
    // フォールバック: CSS トランジションで即時表示
    targets.forEach(function (target) {
      target.classList.add("is-text-reveal-active");
    });
    return;
  }

  window.gsap.registerPlugin(window.ScrollTrigger);

  targets.forEach(function (target) {
    window.gsap.fromTo(
      target,
      { opacity: 0, y: 28 },
      {
        opacity: 1,
        y: 0,
        duration: 1.0,
        ease: "power3.out",
        scrollTrigger: {
          trigger: target,
          start: target.dataset.textRevealStart || "top 88%",
          once: true,
        },
      },
    );
  });
});
